import React from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {inboxHasColor} from '../../../../../helpers/modelHelpers';
import {useAppDispatch, useAppSelector} from '../../../../../helpers/reduxHelpers';
import {InboxModel} from '../../../../../models/api/inboxModel';
import {getFlatChannels} from '../../../../../store/data/channels/channelsSelectors';
import {navigateToLinkAction} from '../../../../../store/stateless/navigationActions';
import {StyledRuleListIconWrapper} from '../../../ruleList/ruleListIcon';
import {
  StyledRuleListWrap,
  StyledRuleListWrapDescription,
  StyledRuleListWrapIcon,
  StyledRuleListWrapTitle,
} from '../../../ruleList/ruleListItem';
import {ChannelPill} from './channelPill';

/*
 * Type.
 */

interface InboxItemProps {
  inbox: InboxModel;
}

const StyledRuleListChannels = styled.div`
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  width: 100%;
`;

/*
 * Component.
 */

export const InboxItem = ({inbox}: InboxItemProps) => {
  const theme = useUserTheme();
  const dispatch = useAppDispatch();
  const channels = useAppSelector(getFlatChannels).filter((c) => c.inboxId === inbox.id);
  const backgroundColor = inboxHasColor(inbox) ? inbox.color : theme.greys.shade50;

  const onClick = () =>
    dispatch(navigateToLinkAction(`/settings/${inbox.namespace}/inboxes/edit/${inbox.id}/overview`));

  return (
    <StyledRuleListWrap onClick={onClick}>
      <StyledRuleListWrapIcon>
        <StyledRuleListIconWrapper $backgroundColor={backgroundColor} $color={theme.greys.white}>
          <Icon name="inboxFilled" />
        </StyledRuleListIconWrapper>
      </StyledRuleListWrapIcon>
      <StyledRuleListWrapTitle>{inbox.name}</StyledRuleListWrapTitle>
      <StyledRuleListWrapDescription>
        <StyledRuleListChannels>
          {channels.map((c) => (
            <ChannelPill channel={c} />
          ))}
        </StyledRuleListChannels>
      </StyledRuleListWrapDescription>
    </StyledRuleListWrap>
  );
};
